module.exports = __webpack_public_path__ + "img/book1.21fcc73d.png";